import RequestedDocument from './RequestedDocument.component';

export default RequestedDocument;